// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vn3u","buttons":"Footer_buttons__20G8Z"};